import http from '../../../../services/http.service';
import { rejectApiError } from '../../../../services/api-error.service';

class LoginService {
  logIn = async (email: string, password: string) => http
    .post('/auth/login-fleet', { email, password })
    .catch(rejectApiError);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LoginService();
